export default __webpack_public_path__ + "static/media/portfolio-simple-2-p6.5342be4c.jpg";